module.exports = __webpack_public_path__ + "static/img/winningList.1fbb137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/winningList.png
// module id = 1JFg
// module chunks = 1